export default {
      id: "icon--basket-empty-usage",
      viewBox: "0 0 20.8 22.4",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--basket-empty-usage",
      toString: function () {
        return this.url;
      }
    }